export class User {
  id: number = null;
  firstName: string = null;
  lastName: string = null;
}
